// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

let LH = 'https://qabooking.inchcape.digital/api/';
 //const incadeaBaseApigeeUrl = "https://api-uat.inchcapedigital.com/v1" // url dev
const incadeaBaseApigeeUrl = 'https://api-uat.inchcapedigital.com/v1'; // url qa
// const incadeaBaseApigeeUrl = 'https://api-uat.inchcapedigital.com/v1'; // url prd

export const environment = {
  production: true,
  UserDealerURL: LH + 'BookingSystem.ApiUserDealer/api/',
  schedulerURL: LH + 'BookingSystem.ApiSchedule/api/',
  blockedAttentionURL: LH + 'BookingSystem.ApiBlockedAttentionSchedule/api/',
  dealerBlockerURL: LH + 'BookingSystem.ApiWorkshopBlockedServices/api/',
  servicesURL: LH + 'BookingSystem.ApiService/api/',
  rolURL: LH + 'BookingSystem.ApiRole/api/',
  userRolURL: LH + 'BookingSystem.ApiUserRole/api/',
  notificationsTemplatesURL: LH + 'BookingSystem.ApiNotificationTemplates/api/',
  notificationTypeURL: LH + 'BookingSystem.ApiNotificationType/api/',
  customerBasicDataUrl: LH + 'BookingSystem.ApiCustomerBasicData/api/',
  vehicleDataUrl: LH + 'BookingSystem.ApiVehicleData/api/',
  brandsUrl: LH + 'BookingSystem.ApiBrand/api/',
  WorkShopURL: LH + 'BookingSystem.ApiWorkshops/api/',
  ServiceAdvisorURL: LH + 'BookingSystem.ApiServiceAdvisors/api/',
  CountryURL: LH + 'BookingSystem.ApiCountry/api/',
  CityURL: LH + 'BookingSystem.ApiCity/api/',
  AttentionSchedule: LH + 'BookingSystem.ApiServiceAttentionSchedule/api/',
  ServiceAdvisorSchedule: LH + 'BookingSystem.ApiServiceAdvisorSchedule/api/',
  ServiceAdvisorBlockedSchedule:
    LH + 'BookingSystem.ApiServiceAdvisorBlockedService/api/',
  ServiceSchedule: LH + 'BookingSystem.ApiServiceSchedule/api/',
  apiUrl: LH + 'BookingSystem.ApiMenu/api/',
  APIRepresentativeURL: LH + 'BookingSystem.ApiRepresentative/api/',
  CustomScheduleUrl: LH + 'BookingSystem.ApiCustomSchedule/api/',
  CustomdashboardUrl: LH + 'BookingSystem.ApiDashboard/api/',
  ServicerDealerUrl: LH + 'BookingSystem.ApiServiceWorkshop/api/',
  ServicerChiefUrl: LH + 'BookingSystem.ApiChiefofWorkshop/api/',
  VehicleRelationShipUrl: LH + 'BookingSystem.ApiRelationshipVehicle/api/',
  originsUrl: LH + 'BookingSystem.ApiScheduleOrigin/api/',
  documentTypesUrl: LH + 'BookingSystem.ApiDocumentType/api/',
  termsAndConditionsUrl: LH + 'BookingSystem.ApiTermsConditionsPolitic/api/',
  WorkshopCountryUrl: LH + 'BookingSystem.ApiWorkshopCountry/api/',
  ReportUrl: LH + 'BookingSystem.ApiReports/api/',
  BloquedReasonUrl: LH + 'BookingSystem.ApiBlockedReason/api/',
  UserManagementUrl: LH + 'BookingSystem.ApiUsers/api/',
};

export const incadeaEnvironment = {
  token: `${incadeaBaseApigeeUrl}/oauth/token`,
  companies: `${incadeaBaseApigeeUrl}/incadea/companies`,
  departments: `${incadeaBaseApigeeUrl}/incadea/service/companies`,
};
export const incadeaConfig = {
  // Usuarios de dev

   //clientId: "63SLpP7CGDEc51v1EW3PlCGTQE8kbip6AZDMzSLyP6rgXjRq",
   //clientSecret: "7pyA0LnqMUBDfM6tij3Nzn7YkxZRcVgRBXo14XF58ZRAmLz4663HGXum8AYA4loI"

  // Usuarios de qa-uat

  clientId: '8y1VgGvtgYDFaQKq7xFUDk3bIHPOMkiWXV1dblvGZ88wMYyK',
  clientSecret:'sUcRJcLX4IYcatkMjs3LfWmocU72AP8wWGIqOTCTcrsTgt3HAohaR9QvlW1TDpA1',
  // usuario de producción

  // clientId: 'qhCOY1cDAaNmd0mXufNJIANR4PJSpJmD1HKUpuariw8EKM1i',
  // clientSecret:
  //   'Koy2bIfhYa5W4YopuwN2hAH2y4vJTbQh6tSP1px5iLiWO7aTSpKWhDEEzvHmfoaY',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.


export const pingIdToken ={
  // DEV
  //clientId: 'hpMWZC6L2razYAGeseW3TumAOUadHYIJYsEyIO2QzQ0yZ3h5',
  //clientSecret:'4u389te8VPb1VcPKPcjQLfziM2oxZoS5hbguc9zpYGDGlG05ZgG9od7vYMIXwBfH'

  // QA
  clientId: 'bVfLHF50w7pGcZvknIMFJ9WEfnSGMM7uo62RUUsGf1b3D1pr',
  clientSecret:'MKBv05aTupv7g8SNklm9IkE4Ha6dT8gA9wss4tqtZ1A3W5fjYSTZ4vAHbWZFiCUg'

  // prod
  // clientId: "uzYzzVIdQRXH4zCG9wcm5YYDv9qcnQd1hACn97HKvngw94Kh",
  // clientSecret:"DAoltjAwKAAjDW2GRFHcJtW5SKJs9tu3OL05JXVT7AlJMJgOhTetLsjWRog7vhDg"
}
// client_id
// bVfLHF50w7pGcZvknIMFJ9WEfnSGMM7uo62RUUsGf1b3D1pr
// client_secret
// MKBv05aTupv7g8SNklm9IkE4Ha6dT8gA9wss4tqtZ1A3W5fjYSTZ4vAHbWZFiCUg
 

//let pingIdURL ='https://api-preprod.inchcapedigital.com/'
// QA
 let pingIdURL ='https://api-preprod.inchcapedigital.com/'
// let pingIdURL ='https://api-preprod.inchcapedigital.com/'

export const environmentPingId ={
  PingIdTokenUrl: pingIdURL + 'v1/oauth/token',
  PingIdvehicleDataUrl :pingIdURL +'dxp-servicebooking/v1/',
}
